// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { productCarouselProductItemStyles } from "@steiner/App/Components/ProductCompare/ProductCarouselProductItem";
import { color, ellipsis, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

productCarouselProductItemStyles.productAddToCartButtonStyles = {
    css: css`
        width: 100%;
    `,
};

productCarouselProductItemStyles.productImageStyles = {
    linkWrappingImage: {
        css: css`
            height: 317px;
        `,
    },
};

productCarouselProductItemStyles.badgeAreaWrapper = {
    css: css`
        position: relative;
    `,
};
productCarouselProductItemStyles.badgeText = {
    weight: "bold",
    css: css`
        width: 100%;
        margin: auto;
        ${wrapInContainerStyles}
    `,
};

productCarouselProductItemStyles.extendedProductGridCarouselContainerStyles = {
    container: {
        css: css`
            display: flex;
            flex-direction: column;
            border-left: 1px solid ${color("common.border")};
            padding-left: 20px;
            ${xScreen("lte", "xs")} {
                border-left: none;
            }
        `,
    },
    addToList: {
        css: css`
            display: flex;
            justify-content: space-between;
        `,
    },
};

productCarouselProductItemStyles.productDescriptionStyles = {
    productDetailLink: {
        css: css`
            min-height: 54px;
            margin-bottom: 16px;
            overflow-wrap: break-word;
            word-break: break-word;
            overflow: visible;
            align-items: flex-start;
            ${ellipsis(2)}
        `,
    },
};

productCarouselProductItemStyles.productPartNumbersStyles = {
    container: {
        css: css`
            flex-grow: 0;
            margin-bottom: 8px;
        `,
    },
    erpNumberLabelText: { size: 12 },
    erpNumberValueText: { size: 12 },
};

productCarouselProductItemStyles.productPriceWrapper = {
    css: css`
        flex-grow: 1;
        margin-bottom: 8px;
        min-height: 44px;
        flex-direction: column;
        justify-content: flex-end;
    `,
};

productCarouselProductItemStyles.productAddToListLinkStyles = {
    link: {
        typographyProps: {
            size: 12,
        },
    },
};
